exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#add_home_screen_popup[data-v-cbe81292]{position:fixed;bottom:48px;background:#f6f5ec;border:1px solid #999;z-index:5001;padding:5px 15px}.showAtBottom[data-v-cbe81292]{bottom:0!important}.container[data-v-cbe81292]{display:flex;align-items:center;margin:5px 15px 5px 0;color:#0a0a0a}.container .logo[data-v-cbe81292]{margin-right:15px}.close-popup[data-v-cbe81292]{color:#666;font-size:2em;line-height:1;font-weight:400;position:absolute;right:10px}", ""]);

// exports
